import { render, staticRenderFns } from "./PersonalInfoTalentFind.vue?vue&type=template&id=33d9b522&scoped=true"
import script from "./PersonalInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTalentFind.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoTalentFind.vue?vue&type=style&index=0&id=33d9b522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9b522",
  null
  
)

export default component.exports